import { FlatfileClient } from '@flatfile/api-internal'
import axios from 'redaxios'
import { OAuth } from '../../auth/oauth'

export class HTTPService {
  private BASE_API_URL = window.location.hostname.includes('localhost')
    ? `${import.meta.env.VITE_API_BASE_URL}`
    : `https://${window.location.hostname}/api`

  public client: FlatfileClient = new FlatfileClient()

  constructor() {
    this.client = new FlatfileClient({
      environment: `${this.BASE_API_URL}/v1`,
      token: () => OAuth.TOKEN || '',
    })
  }

  get axios() {
    axios.defaults.headers = {
      ...axios.defaults.headers,
      Authorization: `Bearer ${OAuth.TOKEN}`,
    }

    axios.defaults.baseURL = this.BASE_API_URL
    return axios
  }
}
